import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrgList, resetOrgDropdownList } from '../../actions/org';
import { actualValueForDropdown, debounce, OrgTypes } from '../../utils/common';
import Select from '../../common/Form/Select';
import { useFormContext } from 'react-hook-form';
import { CLEAR_ORG_LIST_DROPDOWN_LIST_DATA } from '../../types/org';

export default function Customer({ name, label, onChange = () => { }, prefill, required, disabled, className = 'w-full', prefillObj = {}, isMulti = false, get_verification_data, is_rma = false }) {
    const dispatch = useDispatch();
    const methods = useFormContext();
    const orgListDropdown = useSelector((state) => state.org.orgListDropdown);
    const isOrgListLoading = useSelector((state) => state.loading.isOrgListLoading);


    const getOrganisationList = ({ limit = 100, page = 1, query = '', get_verification_data, is_rma }) => {
        dispatch(getOrgList({ limit, page, query, dropdown: true, type: OrgTypes.CUSTOMER, get_verification_data, is_rma }));
    };

    const debouncedOrgSearchSearch = useCallback(debounce(getOrganisationList), []);


    useEffect(() => {
        getOrganisationList({ limit: 100, page: 1, query: '', get_verification_data, is_rma });
        return () => {
            dispatch(resetOrgDropdownList());
        }
    }, []);

    useEffect(() => {
        if (prefillObj && Object.keys(prefillObj).length > 0) {
            methods.setValue(name, prefillObj);
        } else if (prefill && orgListDropdown && orgListDropdown.length > 0) {
            const find = orgListDropdown.find((option) => option.id === prefill);
            if (find) {
                methods.setValue(name, find);
            }
        }
    }, [prefill, orgListDropdown, prefillObj]);


    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_ORG_LIST_DROPDOWN_LIST_DATA });
        }
    }, [dispatch]);

    return (
        <Select
            className={className}
            label={label}
            name={name}
            required={required}
            options={orgListDropdown}
            isLoading={isOrgListLoading}
            onInputChange={(event) => {
                if (event.length > 0) {
                    debouncedOrgSearchSearch({ query: event, get_verification_data, is_rma })
                }
            }}
            onChange={(event) => {
                const orgId = actualValueForDropdown(event);
                if (orgId) {
                    onChange(orgId, event)
                }
            }}
            readOnly={disabled}
            preSelectedIfSingleOption={true}
            isMulti={isMulti}
        />
    )
}
